/**
 * Builds the runtime `OptionResolvers` the engine injects for option sources
 * that need data outside the value map: dynamic options (from the fetched promo
 * config), parent-filtered dim options (supplied by the caller's dim-options
 * hook), and a field's base option list (for `disableByMap` + `option` autofill).
 */
import type { ParsedPromoOptions } from '../../config/parsePromoConfig';
import type { QualifiedId, RuleOption } from '../../config/fieldRulesConfig';
import type { OptionResolvers } from '../types';

interface BuildOptionResolversArgs {
    parsedPromoOptions?: ParsedPromoOptions;
    /** Base option lists keyed by qualified target id (from the field configs). */
    baseOptionsByTarget?: Record<string, RuleOption[]>;
    /** Supplied by the caller (React) to bridge the dim-options hook. */
    filterByParent?: OptionResolvers['filterByParent'];
}

export function buildOptionResolvers(args: BuildOptionResolversArgs = {}): OptionResolvers {
    const { parsedPromoOptions, baseOptionsByTarget = {}, filterByParent } = args;

    return {
        dynamic: (key) => {
            if (!parsedPromoOptions) return undefined;
            if (key === 'promoType') return parsedPromoOptions.promoTypeOptions;
            return undefined;
        },
        filterByParent,
        baseOptions: (target: QualifiedId) => baseOptionsByTarget[target],
    };
}
